import React from 'react';
// Layouts
import { Dialog, DialogTitle, DialogContent } from 'layouts/Dialog';
// Components
import IMedia from 'models/Media';
import { textFromCamelToNormalCase } from 'utilities/utilities';

type Props = {
  open: boolean;
  onClose: () => void;
  media: IMedia | null;
}

const MediaPreviewDialog:React.FC<Props> = ({ open, onClose, media }) => {
  if (!media) return null;
  const title = media.title || textFromCamelToNormalCase(media.format || '');
  return (
    <Dialog size="lg" open={open} onClose={onClose}>
      <DialogTitle title={title} onClose={onClose} />
      <DialogContent>
        <div className="w-full h-full flex justify-center">
          {media.type === 'image' ? (
            <img className="h-full object-contain" src={media.href} alt="" />
          ) : (
            <video className="h-full object-contain" controls>
              <source src={media.href} type="video/mp4" />
            </video>
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default MediaPreviewDialog;
